import { getBridgeSdk } from "@checkout-core/utils";
import { CappingModes } from "@swiggy-private/native-bridge";
import { isEmpty } from "@swiggy-private/js-utils";

const DEFAULT_ENTITY_TYPE = "BANNER";

export const updateFrequencyCount = (cappingMode: CappingModes, entityId: string, entityType?: string) => {
    const _entityType = isEmpty(entityType) ? DEFAULT_ENTITY_TYPE : entityType;

    getBridgeSdk()
        .updateFrequencyCounter({
            cappingMode,
            entityId,
            entityType: _entityType,
        })
        .catch(() => void 0);
};
